import ShareBtn from './ShareBtn';

export default ShareBtn;
